import { BrowserRouter, Routes, Route } from "react-router-dom";
import Inicio from "./pages/Inicio";
import Layout from "./pages/Layout";
import Matricula from "./pages/Matricula";


import Auth from "./pages/Auth";
import Login from "./pages/Login";
import OlvidePassword from "./pages/OlvidePassword";
import Success from "./pages/Success";
import ValidacionSeguridad from "./pages/ValidacionSeguridad";
import RestaurarPassword from "./pages/RestaurarPassword";

import AuthProvider from "./context/AuthProvider";
import MatriculaProvider from "./context/MatriculaProvider";
import ProcesoMatriculaProvider from "./context/ProcesoMatriculaProvider";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import PagoFinish from "./pages/Payme/PagoFinish";
import PagoPreRespuesta from "./pages/Payme/PagoPreRespuesta";
import PagoNotificacion from "./pages/Payme/PagoNotificacion";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Desactivar refetching globalmente
      retry: 1, // Retry en caso de error
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>

      <BrowserRouter>
        <AuthProvider>
          <MatriculaProvider>
            <ProcesoMatriculaProvider>
              <Routes>
                <Route path="/" element={<Layout />}>
                  <Route index element={<Inicio />} />

                  <Route path="matricula" element={<Matricula />} />

                  <Route path="*" element={<Inicio />} />
                </Route>

                <Route path="auth" element={<Auth />}>
                  <Route index element={<Login />} />
                  <Route path="forgotPassword" element={<OlvidePassword />} />
                  <Route
                    path="validateCode/:token"
                    element={<ValidacionSeguridad />}
                  />
                  <Route
                    path="ressetPassword/:token"
                    element={<RestaurarPassword />}
                  />
                  <Route path="success" element={<Success />} />
                  <Route path="*" element={<Login />} />
                </Route>
                
                <Route path="/payme/finish" element={<PagoFinish />} />
                <Route path="/payme/pre-respuesta" element={<PagoPreRespuesta />} />
                <Route path="/payme/notificacion-pago" element={<PagoNotificacion />} />
                
              </Routes>
            </ProcesoMatriculaProvider>
          </MatriculaProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}

export default App;
